import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aa509dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center text-2xl font-bold" }, "Contact"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-300 md:max-w-screen-sm lg:max-w-screen-md mx-auto" }, [
    /*#__PURE__*/_createElementVNode("p", null, " Need help? Have a feature request? Want to see other journals? Just want to say hi? "),
    /*#__PURE__*/_createElementVNode("p", null, "Send us a message!")
  ])
], -1))
const _hoisted_2 = {
  key: 0,
  class: "text-red-700"
}
const _hoisted_3 = {
  key: 1,
  class: "text-green-600"
}
const _hoisted_4 = { class: "rounded-md shadow-sm form-inputs" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold" }, "Message Topic", -1))
const _hoisted_7 = ["errors"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select a Message Topic", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "mt-6" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_textarea = _resolveComponent("base-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      class: "my-6 max-w-md mx-auto",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      (_ctx.errors)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.errors), 1))
        : _createCommentVNode("", true),
      (_ctx.success)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.success), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.topic) = $event)),
            class: "field",
            errors: _ctx.v$.topic.$errors,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validate()))
          }, [
            _hoisted_8,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Support', 'Feature Request', 'Feedback', 'Journal Request', 'Data Issue', 'Other'], (option) => {
              return _createElementVNode("option", {
                value: option,
                key: option
              }, _toDisplayString(option), 9, _hoisted_9)
            }), 64))
          ], 40, _hoisted_7), [
            [_vModelSelect, _ctx.topic]
          ])
        ]),
        _createVNode(_component_base_input, {
          modelValue: _ctx.subject,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.subject) = $event)),
          label: "Subject",
          type: "text",
          required: true,
          errors: _ctx.v$.subject.$errors,
          onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validate()))
        }, null, 8, ["modelValue", "errors"]),
        _createVNode(_component_base_textarea, {
          modelValue: _ctx.message,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.message) = $event)),
          label: "Message",
          required: true,
          errors: _ctx.v$.message.$errors,
          onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validate()))
        }, null, 8, ["modelValue", "errors"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.isDisabled,
          class: "btn btn-primary btn-large w-full"
        }, " Send Message ", 8, _hoisted_11)
      ])
    ], 32)
  ], 64))
}